export enum TewerkstellingsStatus {
  InProgress = 1,
  Accepted = 2,
  Rejected = 3,
  NeedsChange = 4,
}
